module.exports = __webpack_public_path__ + "img/DigitalSpital.a7175ad7.svg";